/**
 * Explain: 项目中接口调用
 * */

import JSON_URL from '../api/api-jsonUrl'
import request from './api-client'
// import { uploadFile } from './api-client'

/**
 * 请求方式：POST
 * 使用说明：溯源反馈提交(formData)
 * 使用场景：溯源反馈提交
 * * */
// export const actionTraceUpload = (formData) => {
//   return uploadFile({
//     url: `${JSON_URL.GET_ACTION_TRACE}`,
//     data: formData
//   });
// };

/**
 * 请求方式：POST
 * 使用说明：获取高德天气
 * 使用场景：获取高德天气
 * * */
export const getWeatherInfo = (params, type = 'json') => {
	return request({
		url: `${JSON_URL.GET_WEATHER_INFO}`,
		method: 'GET',
		data: params,
		type
	})
}
